module.exports = __webpack_public_path__ + "assets/CDoubleSegDetailed.fa1e245fc7beb56c572b74aa2efcdb34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CDoubleSegDetailed.png
// module id = 472
// module chunks = 0